import { useStore } from 'effector-react';
import { toaster } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React, { useEffect, useState } from 'react';
import { Interest } from 'src/domain/interest';
import { fetchInterestsBlocksFx, fetchInterestsFx, interests$, interestsBlocks$ } from 'src/store/interests.store';
import { updateUserInterestsFx, user$ } from 'src/store/user.store';
import { Button } from 'src/ui/atoms/button';
import { Tag } from 'src/ui/atoms/tag';
import { InterestsBlocks } from 'src/ui/molecules/interests-blocks';

const InterestsBlock = styled.div`
	padding: 16px 0;
	
	&[data-bordered='true'] {
		border-top: 1px solid var(--gray500);
	}
`;
const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
`;

export const ProfileInterestsPage = () => {
	const user = useStore(user$);
	const interests = useStore(interests$);
	const interestsBlocks = useStore(interestsBlocks$);
	const [selectedInterests, updateSelectedInterest] = useState<Interest[]>([]);

	const addInterest = (interest: Interest) => {
		updateSelectedInterest([
			...selectedInterests,
			interest,
		]);
	};
	const removeInterests = (interest: Interest) => {
		updateSelectedInterest(
			selectedInterests.filter(item => item.id !== interest.id),
		);
	};

	useEffect(() => {
		fetchInterestsFx();
		fetchInterestsBlocksFx();
	}, []);
	useEffect(() => {
		console.log(user?.interests);
		updateSelectedInterest(user?.interests || []);
	}, [user]);

	const handleSave = async () => {
		console.log(selectedInterests);
		await updateUserInterestsFx(
			selectedInterests.map(item => item.id),
		);
		toaster.notify('Profile updated');
	};

	return (
		<>
			<InterestsBlocks
				blocks={interestsBlocks}
				interests={selectedInterests}
				onChange={(payload) => {
					if (payload.checked) {
						const interests = selectedInterests
							.filter(item => item.block?.id !== payload.interest.block?.id);

						updateSelectedInterest([...interests, payload.interest]);
					} else {
						removeInterests(payload.interest);
					}
				}}
			/>
			<InterestsBlock>
				{selectedInterests
					.filter(item => !item.block)
					.map(interest => (
						<Tag
							key={interest.id}
							onClick={() => removeInterests(interest)}
						>
							{interest.name}
						</Tag>
					))}
			</InterestsBlock>
			<InterestsBlock data-bordered={selectedInterests.length > 0}>
				{interests.map(item => (
					<Tag
						key={item.id}
						style={{
							display: selectedInterests.find(a => a.id === item.id) ? 'none' : 'inline-block',
						}}
						onClick={() => addInterest(item)}
					>
						{item.name}
					</Tag>
				))}
			</InterestsBlock>
			<ButtonContainer>
				<Button onClick={handleSave}>Save</Button>
			</ButtonContainer>
		</>
	);
};
